import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'

import { wbeStore, subjectStore } from 'mobileApp/store'
import { WbeLayout } from 'mobileApp/wbe/layout'
import { PAYMENT_CLAUSE_MAP, PaymentType } from 'mobileApp/constants/constants'

export const S12Confirmation: FC<RouteComponentProps> = props => {
  const { paymentType, paymentTypeDesc } = wbeStore
  const { premium } = wbeStore.currentOption
  const { name } = wbeStore.policyHolderInfo
  const { supNo, imei, subjectId } = wbeStore.accessoriesInfo
  const paymentStatus = wbeStore.isPaymentSuccessful ? '繳款成功' : '繳款失敗'
  const { mara } = subjectStore.getSubjectById(subjectId)[0]

  const paymentDependentClause = PAYMENT_CLAUSE_MAP[paymentType as PaymentType]

  return (
    <WbeLayout title="投保完成" step={5}>
      <section className="text-center">
        <h4 className="font-weight-normal my-3">您已完成投保！</h4>
        <h5 className="font-weight-normal mb-4">將於核保後 10 個工作天 內寄發電子保單簡訊至您的手機號碼！</h5>
      </section>
      <section className="row">
        <div className="col-4 text-muted mb-3">投保險種</div>
        <div className="col-8 text-primary">{paymentDependentClause?.title ?? '-'}</div>

        <div className="col-4 text-muted mb-3">繳款方式</div>
        <div className="col-8 text-primary">{paymentTypeDesc}</div>

        <div className="col-4 text-muted mb-3">保險費</div>
        <div className="col-8 text-primary">新台幣 {premium} 元</div>

        <div className="col-4 text-muted mb-3">要保人姓名</div>
        <div className="col-8 text-primary">{name}</div>

        <div className="col-4 text-muted mb-3">廠牌型號</div>
        <div className="col-8 text-primary">{`${supNo} - ${mara}`}</div>

        <div className="col-4 text-muted mb-3">IMEI / Serial No.</div>
        <div className="col-8 text-primary">{imei}</div>

        <div className="col-4 text-muted mb-3">繳款結果</div>
        <div className="col-8 text-primary">{paymentStatus}</div>
      </section>

      <section className="my-3 d-flex justify-content-between">
        <span>&nbsp;</span>
        <button type="button" className="btn btn-secondary" onClick={() => props.history.push('/system/home')}>
          投保完成
        </button>
      </section>
    </WbeLayout>
  )
}
